import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=bf04b9fa&"
import script from "./Analysis.vue?vue&type=script&lang=js&"
export * from "./Analysis.vue?vue&type=script&lang=js&"
import style0 from "./Analysis.vue?vue&type=style&index=0&id=bf04b9fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports